import { useQueryClient } from "@tanstack/react-query";
import { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAPI from "../api/hooks/useAPI";
import { bootstrapKeys } from "../api/queryKeys";
import { ONBOARDING_STEPS } from "../utils/constants";
import { BootstrapContext } from "./BootstrapContext";

const OnboardingContext = createContext({
  currentStage: "welcome",
  isLoading: false,
  setOnboardingStage: () => {},
  isOnboardingModalOpen: false,
  openOnboardingModal: () => {},
  closeOnboardingModal: () => {},
});

export const OnboardingProvider = ({ children }) => {
  const { updateOnboardingStage, trackEvent } = useAPI();
  const { onboardingStage, isLoading } = useContext(BootstrapContext);
  const queryClient = useQueryClient();
  const [isOnboardingModalOpen, setIsOnboardingModalOpen] = useState(false);
  const navigate = useNavigate();

  const setOnboardingStage = async (stage) => {
    try {
      await updateOnboardingStage(stage).then(() => {
        trackEvent(`User updated onboarding stage to ${stage}`);
        queryClient.invalidateQueries({
          queryKey: bootstrapKeys.all,
        });
        if (stage === ONBOARDING_STEPS.COMPLETED) {
          navigate("/");
          closeOnboardingModal();
        }
      });
    } catch (error) {}
  };

  const openOnboardingModal = () => {
    setIsOnboardingModalOpen(true);
  };

  const closeOnboardingModal = () => {
    setIsOnboardingModalOpen(false);
    if (
      onboardingStage === ONBOARDING_STEPS.SCAN_COMPLETE ||
      onboardingStage === ONBOARDING_STEPS.LEARN_BASICS
    ) {
      navigate("/");
    }
  };

  return (
    <OnboardingContext.Provider
      value={{
        currentStage: onboardingStage,
        isLoading,
        setOnboardingStage,
        isOnboardingModalOpen,
        openOnboardingModal,
        closeOnboardingModal,
      }}
    >
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboarding = () => {
  const context = useContext(OnboardingContext);
  return context;
};
